module.exports = __webpack_public_path__ + "img/tm-findText.a90735af.svg";